// extracted by mini-css-extract-plugin
module.exports = {"left-menu":"style_left-menu__2Ds8N","fade-in-gradient":"style_fade-in-gradient__HgNxl"};